import * as React from 'react';
import mainColors from '../../../themes/main-colors';

type ResidentialIconProps = React.SVGProps<SVGSVGElement> & {
  isSelected?: boolean;
  /** Width/Height override (default uses original svg width/height) */
  size?: number | string;
};

export const ResidentialIcon: React.FC<ResidentialIconProps> = ({
  isSelected = false,
  size = 24,
  ...props
}) => {
  const stroke = isSelected ? mainColors.white : mainColors.sparkBlue;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={'0 0 98.137 97'}
      {...props}
    >
      <g fill="none" stroke={stroke} strokeWidth={4}>
        <path
          data-name="house"
          strokeLinejoin="round"
          d="M86.247 96H12.059V56.855l.012-.011C13.553 55.486 48.364 23.6 49.031 23.6s36.851 33.2 37.216 33.531zM32.492 59.278l-.033 28.761h19.713l.029-28.761zm29.563 0v14.333h11.646V59.278H62.059Z"
        />
        <path d="M27.228 88.07H57.46a1 1 0 0 1 1 1v6.929H26.228V89.07a1 1 0 0 1 1-1Z" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m1.508 57.841 3.582 3.79a1.27 1.27 0 0 0 1.8.066c40.982-37.615 42.1-38.231 42.1-38.231s.682.035 42.088 38.249a1.27 1.27 0 0 0 1.771-.029l3.888-3.848a1.38 1.38 0 0 0 0-1.943L81.261 40.486a1.37 1.37 0 0 1-.4-.97V18.13H66.219v8.61L48.986 10.951 1.537 55.929a1.38 1.38 0 0 0-.029 1.912"
        />
      </g>
    </svg>
  );
};
